import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { TeamTemplateActions, TeamTemplateActionTypes } from "../_actions";
import { TeamTemplateModel } from "../_models";

export interface TeamTemplateState extends EntityState<TeamTemplateModel> {
    isLoading: boolean;
    total: number;
}
export const adapter: EntityAdapter<TeamTemplateModel> = createEntityAdapter<TeamTemplateModel>();
export const initialState: TeamTemplateState = adapter.getInitialState({
    isLoading: false,
    total: 0
});

export function teamTemplateReducer(state = initialState, action: TeamTemplateActions): TeamTemplateState {
    switch (action.type) {
        case TeamTemplateActionTypes.LOAD_TEAM_TEMPLATES: {
            return {
                ...state,
                isLoading: true
            };
        }
        case TeamTemplateActionTypes.TEAM_TEMPLATES_LOADED: {
            return adapter.setAll(action.payload.templates, {
                ...state,
                isLoading: false,
                total: action.payload.total
            })
        }
        case TeamTemplateActionTypes.ADD_TEAM_TEMPLATE: {
            return state;
        }
        case TeamTemplateActionTypes.TEAM_TEMPLATE_ADDED: {
            return adapter.addOne(action.payload.template, state);
        }
        case TeamTemplateActionTypes.UPDATE_TEAM_TEMPLATE: {
            return state;
        }
        case TeamTemplateActionTypes.TEAM_TEMPLATE_UPDATED: {
            return adapter.updateOne(action.payload.template, state);
        }
        case TeamTemplateActionTypes.DELETE_TEAM_TEMPLATE: {
            return state;
        }
        case TeamTemplateActionTypes.TEAM_TEMPLATE_DELETED: {
            return adapter.removeOne(action.payload.id, state);
        }
        default: {
            return state;
        }
    }
}